module.exports = __webpack_public_path__ + "robot.9b794227dd5b45b91582.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/admin-portal-2/admin-portal-2/src/assets/robot.svg
// module id = ../../../../../src/assets/robot.svg
// module chunks = 9